module.exports = __webpack_public_path__ + "static/media/36-12.95b69c9c.mp3";